import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '13.71 7.5898'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M25.4498 1.58984C25.4498 1.58984 21.2998 3.31982 13.7298 3.31982C6.15976 3.31982 2.00977 1.58984 2.00977 1.58984C6.31977 10.8298 10.9798 12.5698 13.7298 12.5698C16.4698 12.5698 21.1398 10.8398 25.4498 1.58984Z"
          fill="white"
        />
        <path
          d="M13.71 14.6298C4.84 14.6298 0 0.549805 0 0.549805C0 0.549805 6.47 2.07983 13.71 2.07983C20.95 2.07983 27.42 0.549805 27.42 0.549805C27.42 0.549805 22.58 14.6298 13.71 14.6298ZM3.28 3.2298C7.16 10.4298 11.67 11.5698 13.72 11.5698C15.77 11.5698 20.33 10.4298 24.21 3.2298C22.19 3.7298 18.19 4.31982 13.72 4.31982C9.25 4.31982 5.3 3.7398 3.28 3.2298Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
